import React, { Component } from "react";
import 'antd/dist/antd.css';
import { Spinner } from 'reactstrap';
import axios from '../../../utils/request';
import { Result, Button, Input, message } from 'antd';
import '../cccltd.css'
const { TextArea } = Input;

//候选人申诉
export class CCCCLTDApplicantApply extends Component {
    constructor(props) {
        super(props);
        this.state = {
            applyId: "",
            timeStamp: "",
            tenantId: "",
            userId: "",
            signValue: "",
            isReady: false,
            isLoading: true,
            errorMessage: "",
            infoMsg: "",
            canSubmt: false
        }
    };
    componentDidMount() {
        const urlParams = new URLSearchParams(window.location.search);
        const applyId = urlParams.get("applyId");
        const timeStamp = urlParams.get("timeStamp");
        const tenantId = urlParams.get("tenantId");
        const userId = urlParams.get("userId");
        const signValue = urlParams.get("signValue");
        if (!applyId) {
            this.setState({ errorMessage: "应聘者申请Id不存在！", isLoading: false, isReady: true });
            return;
        }
        this.setState({ applyId, timeStamp, tenantId, userId, signValue });
        this.loadPage(tenantId, userId, applyId, timeStamp, signValue);
    };
    loadPage = (tenantId, userId, applyId, timeStamp, signValue) => {
        const params = {
            tenantId,
            userId,
            applyId,
            timeStamp,
            signValue
        }
        axios
            .get("/api/CCCCLTD/GetTwiceApplyInfo", { params: params })
            .then(res => {
                const reqCode = res.data.code;
                const orgResInfo = res.data.data;
                let canSubmt = false;
                let infoMsg = "";
                let errorMessage = "";
                if (reqCode != "200") {
                    errorMessage = "获取详细信息失败！错误信息：" + res.data.message;
                } else {
                    canSubmt = orgResInfo["canSubmit"];
                    infoMsg = orgResInfo["infoMsg"];
                }
                this.setState({ isLoading: false, isReady: true, errorMessage, canSubmt, infoMsg });

            })
            .catch(reason => {
                this.setState({ isLoading: false, isReady: true, errorMessage: "操作异常，请联系管理员！" + reason.response.data.message });
            })
            .finally(
            );
    };
    agree = () => {
        let reason = document.getElementById("reason").innerHTML;
        let reason1 = reason.replace(/\n/g, "");
        if (reason1.length <= 0) {
            message.error('再次申请理由不能为空，请输入再次申请理由！');
            return;
        };
        const params = {
            tenantId: this.state.tenantId,
            userId: this.state.userId,
            applyId: this.state.applyId,
            timeStamp: this.state.timeStamp,
            signValue: this.state.signValue,
            reason: reason
        }
        axios
            .get("/api/CCCCLTD/ApplyAgain", { params: params })
            .then(res => {
                const reqCode = res.data.code;
                const orgResInfo = res.data.data;
                let canSubmt = false;
                let infoMsg = "";
                let errorMessage = "";
                if (reqCode != "200") {
                    errorMessage = "再次申请操作失败！错误信息：" + res.data.message;
                } else {
                    canSubmt = orgResInfo["canSubmit"];
                    infoMsg = orgResInfo["infoMsg"];
                }
                this.setState({ isLoading: false, isReady: true, errorMessage, canSubmt, infoMsg });
            })
            .catch(reason => {
                this.setState({ isLoading: false, isReady: true, errorMessage: "操作异常，请联系管理员！" + reason.response.data.message });
            })
            .finally(
            );
    };
    refuse = () => {
        let reason = document.getElementById("reason").innerHTML;
        let reason1 = reason.replace(/\n/g, "");
        if (reason1.length <= 0) {
            message.error('放弃申请理由不能为空，请输入放弃申请理由！');
            return;
        };
        const params = {
            tenantId: this.state.tenantId,
            userId: this.state.userId,
            applyId: this.state.applyId,
            timeStamp: this.state.timeStamp,
            signValue: this.state.signValue,
            reason: reason
        }
        axios
            .get("/api/CCCCLTD/Abandon", { params: params })
            .then(res => {
                const reqCode = res.data.code;
                const orgResInfo = res.data.data;
                let canSubmt = false;
                let infoMsg = "";
                let errorMessage = "";
                if (reqCode != "200") {
                    errorMessage = "放弃操作失败！错误信息：" + res.data.message;
                } else {
                    canSubmt = orgResInfo["canSubmit"];
                    infoMsg = orgResInfo["infoMsg"];
                }
                this.setState({ isLoading: false, isReady: true, errorMessage, canSubmt, infoMsg });
            })
            .catch(reason => {
                this.setState({ isLoading: false, isReady: true, errorMessage: "操作异常，请联系管理员！" + reason.response.data.message });
            })
            .finally(
            );
    };

    render() {
        if (this.state.isReady) {
            if (this.state.errorMessage !== "") {
                return (<div style={{ textAlign: "center", padding: "32px" }}><span style={{ color: "red" }}>{this.state.errorMessage}</span></div>)
            } else {
                if (this.state.canSubmt) {
                    return (<Result
                        key="r1"
                        extra={[
                            <br key="b1" />,
                            <p key="p1" style={{ textAlign: "center", fontSize: "17px", marginRight: "0" }}>{this.state.infoMsg}</p>,
                            <br key="b2" />,
                            <p key="p2" style={{ textAlign: "center", fontSize: "17px", marginRight: "0" }}>
                                <TextArea id="reason" placeholder="再次申请或放弃申请时请输入理由" style={{ maxWidth: "400px" }} />
                            </p>,
                            <br key="b3" />,
                            <p key="p3" style={{ textAlign: "center", marginRight: "0" }}>
                                <Button type="primary" onClick={this.agree} style={{ marginLeft: "0" }}>再次申请</Button>
                                <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                                <Button onClick={this.refuse} style={{ marginRight: "0" }}>放弃申请</Button>

                            </p>
                        ]} />)
                } else {
                    return (<Result
                        status="success"
                        key="r1"
                        extra={[
                            <br key="b1" />,
                            <p key="p1" style={{ textAlign: "center", fontSize: "17px", marginRight: "0" }}>{this.state.infoMsg}</p>
                        ]}

                    />)
                }

            }
        }
        else {
            return (
                <div style={{ textAlign: "center", padding: "15px" }}>
                    <Spinner type="grow" color="primary" />
                    <Spinner type="grow" color="secondary" />
                    <Spinner type="grow" color="success" />
                    <Spinner type="grow" color="danger" />
                    <Spinner type="grow" color="warning" />
                    <Spinner type="grow" color="info" />
                    <Spinner type="grow" color="dark" />
                </div>
            );
        }

    }
}